<template>
	<div id="login">
		<div class="login-wrapper">
			<form class="login-form" method="POST" v-on:submit.prevent="recover">
				<div class="login-container">
					<div class="login-header">
						<Logo />
					</div>
					<div class="form-fields">
						<h1 class="title is-4">Forgot your password?</h1>
						<p>Enter your email address below to reset your password.</p>
						<b-notification
							type="is-danger"
							v-if="error"
							:closable="false">
							{{ error }}
						</b-notification>
						<b-notification
							type="is-success"
							v-if="resetSuccess"
							:closable="false">
							{{ resetSuccess }}
						</b-notification>
						<b-field
							v-if="!resetSuccess"
							label="Email"
							:type="feedback.email.type"
							:message="feedback.email.message">
							<b-input v-model.trim="input.email"
							         ref="email"
							         type="email"
							         autofocus>
							</b-input>
						</b-field>
					</div>
					<div class="login-footer">
						<router-link to="login"
						             class="button is-info has-icon pull-left"
						             type="submit">
							<b-icon icon="chevron-left"></b-icon>
							<span class="button-label">Back to Login</span>
						</router-link>
						<button v-if="!resetSuccess"
						        href="#"
						        class="button is-primary has-icon pull-right"
						        :disabled="processing"
						        type="submit">
							<b-icon icon="key"></b-icon>
							<span class="button-label">Recover Password</span>
						</button>
					</div>
				</div>
			</form>
			<p class="login-copyright">&copy; {{ new Date().getFullYear() }} &ndash; {{ title }}. All rights reserved.</p>
		</div>
	</div>
</template>

<style lang="scss">

</style>

<script>
import Logo from './Icons/Logo'
import { AUTH_FORGOT } from '../store/actions/auth'
import { mapGetters, mapMutations } from 'vuex'

export default {
  components: {
    Logo
  },
  data () {
    return {
      title: process.env.NAME,
      input: {
        email: ''
      },
      feedback: {
        'email': {
          'type': '',
          'message': ''
        }
      },
      error: '',
      resetSuccess: '',
      processing: false
    }
  },
  computed: mapGetters({
    isAuthenticated: 'isAuthenticated'
  }),
  methods: {
    ...mapMutations([
      'setPageTitle'
    ]),
    validateEmail () {
      this.error = ''
      this.feedback.email.type = ''
      this.feedback.email.message = ''

      if (this.input.email === '') {
        this.feedback.email.type = 'is-danger'
        this.feedback.email.message = 'Email cannot be blank'
        this.processing = false
        return false
      }

      return true
    },
    recover () {
      this.processing = true
      if (this.validateEmail()) {
        const { email } = this.input
        this.$store.dispatch(AUTH_FORGOT, { email }).then(response => {
          this.resetSuccess = response.message
        }).catch(error => {
          this.processing = false

          if (error.hasOwnProperty('response')) {
            if (error.response.data.response === 'error') {
              this.error = error.response.data.message
              this.input.password = ''
              this.$refs.password.focus()
            }

            if (error.response.data.response === 'validationError') {
              let fields = error.response.data.data
              for (const prop in fields) {
                if (fields.hasOwnProperty(prop)) {
                  if (this.feedback.hasOwnProperty(prop)) {
                    this.feedback[prop].type = 'is-danger'
                    this.feedback[prop].message = fields[prop]
                  }
                }
              }
            }
          } else {
            this.$buefy.toast.open({
              message: error.toString(),
              type: 'is-danger'
            })
          }
        })
      }
    }
  },
  mounted () {
    this.$refs.email.focus()
    this.setPageTitle('Password Reset')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ForgotPassword.vue